// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__m4iGI","copyright":"Footer_copyright__1SemZ"};